var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-center align-center"},[_c('v-progress-circular',{attrs:{"color":_vm.color,"size":_vm.size,"indeterminate":""}}),(_vm.label)?_c('div',{staticClass:"ma-4 text--secondary",domProps:{"textContent":_vm._s(_vm.label)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }